import { render, staticRenderFns } from "./ra-search-box.vue?vue&type=template&id=8fcdea3a&scoped=true"
import script from "./ra-search-box.vue?vue&type=script&lang=js"
export * from "./ra-search-box.vue?vue&type=script&lang=js"
import style0 from "./ra-search-box.vue?vue&type=style&index=0&id=8fcdea3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcdea3a",
  null
  
)

export default component.exports